import { useLang } from "@/context/LanguageContext";

const Marquee = () => {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div
      data-testid="marquee-banner"
      className="bg-[#ff0033] overflow-hidden whitespace-nowrap py-3 border-y border-black/20 select-none"
    >
      <div className="inline-flex animate-marquee">
        {[0, 1].map((i) => (
          <span
            key={i}
            className="font-heading text-2xl md:text-4xl text-black uppercase tracking-tight px-4"
          >
            {text}&nbsp;&nbsp;{text}&nbsp;&nbsp;
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
